import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TalentPoolReportModalComponent } from './talent-pool-report-modal.component';
import { ButtonModule, DropdownModule, MultiSelectModule } from "@xref/xref-lib";
import {
  DateRangePickerPopoverV2Module
} from "../../lib/app-date-range-picker-popover-v2/date-range-picker-popover-v2.module";
import { LoaderModule } from "../loader/loader.module";


@NgModule({
  declarations: [TalentPoolReportModalComponent],
  imports: [
    CommonModule,
    ButtonModule,
    DropdownModule,
    MultiSelectModule,
    DateRangePickerPopoverV2Module,
    LoaderModule,
  ],
  exports: [TalentPoolReportModalComponent]
})
export class TalentPoolReportModalModule { }
